import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'uex-dialog-title',
  templateUrl: './title.component.html',
})
export class DialogTitleComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}

/**
 * @ignore
 */
@Component({
  selector: '[uex-dialog-title]',
  template: '<ng-content></ng-content>',
  host: {
    class: 'uex-dialog-title modal-title'
  }
})
export class DialogHeadingTitleComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
